<template>
  <pt-branch-company-table class="pt-branch-company-table__page"></pt-branch-company-table>
</template>

<script>
import PtBranchCompanyTable from 'cps//branch-company-manage/pt-branch-company/pt-branch-company-table/withData'
export default {
  name: 'pt-branch-company-table__view',
  components: {
    'pt-branch-company-table': PtBranchCompanyTable
  }
}
</script>
